import * as React from 'react'
import * as XLSX from 'xlsx'
import * as Papa from 'papaparse'
import { CurrentCompanyStore } from '../../../../../stores/CurrentCompanyStore'
import { BaseComplianceReportRequest, API } from '@getgreenline/homi-shared'
import { FormError } from '../../../../../components/FormError'
import { ComplianceStore } from '../ComplianceStore'
import { Button } from 'antd'
import { Track } from '../../../../../Track'

interface Props {
  currentCompanyStore: CurrentCompanyStore
  complianceStore: ComplianceStore
}

interface State {
  isLoading: boolean
  errorMessage?: string
}

export class Alberta extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isLoading: false,
    }
  }

  generate() {
    const { locations } = this.props.currentCompanyStore
    const { month, year, locationIds } = this.props.complianceStore
    const params: BaseComplianceReportRequest = {
      month,
      year,
      locationIds,
    }

    Track.track('dashboard:compliance_complianceReportGenerated', params)

    const company = this.props.currentCompanyStore.company!
    this.setState({ isLoading: true })

    API.getComplianceReport(company.id, 'AB', params)
      .then((response) => {
        this.setState({ isLoading: false })
        const parsedData = Papa.parse(response)
        /* convert from array of arrays to workbook */
        const worksheet = XLSX.utils.aoa_to_sheet([[], [], [], ...parsedData.data])
        const new_workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(new_workbook, worksheet, 'Inventory and Sales')
        const title = this.props.complianceStore.generateFileName(company.name, 'xlsx')
        XLSX.writeFile(new_workbook, title)
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          errorMessage: error.response.data.message,
        })
      })
  }

  render() {
    const { isLoading, errorMessage } = this.state
    const { locationIds } = this.props.complianceStore

    return (
      <div>
        <div>
          <Button
            type='primary'
            onClick={() => this.generate()}
            loading={locationIds.length === 0 || isLoading}
          >
            {isLoading ? 'Downloading...' : 'Download report'}
          </Button>
        </div>
        <FormError message={errorMessage} />
      </div>
    )
  }
}
